import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getSubscriptionPlanDetails } from "../../redux/services/SubscriptionServices/Subscription.Services";

function ViewPlan() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---------- Helpers ----------
  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  const formatPrice = (val) =>
    val !== null && val !== undefined && val !== ""
      ? `₹${Number(val).toFixed(2)}`
      : "-";

  const formatLimit = (val) =>
    val === -1 ? "Unlimited" : val ?? 0;

  // ---------- Fetch Plan Details ----------
  const fetchSubscriptionDetails = async () => {
    try {
      setLoading(true);
      const res = await getSubscriptionPlanDetails(id);

      // Response shape: { success, message, data: {...plan...} }
      let data = null;
      if (res?.success && res?.data) {
        data = res.data;
      } else if (res?.data?.data) {
        data = res.data.data;
      } else if (res?.id) {
        data = res;
      }

      setSubscription(data || null);
    } catch (error) {
      console.log("Error:", error);
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchSubscriptionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ---------- Loading ----------
  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3">Loading Subscription Details...</h5>
      </div>
    );
  }

  // ---------- Not Found ----------
  if (!subscription) {
    return (
      <div className="text-center py-5">
        <h5>Subscription not found</h5>
        <button className="add-btn mt-3" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Plan Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/subscription-list">Subscriptions</Link>
            <span className="mx-2">/</span>
            <span>View</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card mt-2">
          <div className="card-body p-4">
            {/* ===== PLAN INFORMATION ===== */}
            <div className="mb-4">
              <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                Plan Information
              </h6>

              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Plan Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subscription.name || "-"}
                    readOnly
                  />
                </div>

                {subscription.module && (
                  <div className="col-md-6">
                    <label className="form-label">Module Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={subscription.module.name || "-"}
                      readOnly
                    />
                  </div>
                )}

                

                <div className="col-md-12">
                  <label className="form-label">Description</label>
                  <textarea
                    rows={2}
                    className="form-control"
                    value={subscription.description || "-"}
                    readOnly
                  />
                </div>
              </div>
            </div>

            {/* ===== PRICING ===== */}
            <div className="mb-4">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">AI Call Limit</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatLimit(subscription.ai_call_limit)}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Original Price</label>
                  <input
                    type="text"
                    className="form-control view-original-price"
                    value={formatPrice(subscription.original_price)}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Price</label>
                  <input
                    type="text"
                    className="form-control view-price"
                    value={formatPrice(subscription.price)}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Status</label>
                  <input
                    type="text"
                    className={`form-control ${subscription.status === 1
                      ? "view-status-active"
                      : "view-status-inactive"
                      }`}
                    value={subscription.status === 1 ? "Active" : "Inactive"}
                    readOnly
                  />
                </div>




                {/* <div className="col-md-4">
                  <label className="form-label">Duration (Days)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subscription.duration_days ?? "-"}
                    readOnly
                  />
                </div> */}
              </div>
            </div>

            {/* ===== PLAN LIMITS ===== */}
            <div className="mb-4">

              <div className="row g-3">


                {/* <div className="col-md-4">
                  <label className="form-label">Staff Limit</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatLimit(subscription.staff_limit)}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Product Limit</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatLimit(subscription.product_limit)}
                    readOnly
                  />
                </div> */}
              </div>
            </div>

            {/* ===== DISPLAY SETTINGS ===== */}
            {/* <div className="mb-4">
              <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                Display Settings
              </h6>

              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Badge Text</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subscription.badge_text || "-"}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Is Popular</label>
                  <input
                    type="text"
                    className="form-control"
                    value={Number(subscription.is_popular) ? "Yes" : "No"}
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Sort Order</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subscription.sort_order ?? 0}
                    readOnly
                  />
                </div>
              </div>
            </div> */}

            {/* ===== MODULE ===== */}
            <div className="mb-4">
              <div className="row g-3">


                {/* <div className="col-md-6">
                    <label className="form-label">Module Slug</label>
                    <input
                      type="text"
                      className="form-control"
                      value={subscription.module.slug || "-"}
                      readOnly
                    />
                  </div>

                  <div className="col-md-12">
                    <label className="form-label">Module Description</label>
                    <textarea
                      rows={2}
                      className="form-control"
                      value={subscription.module.description || "-"}
                      readOnly
                    />
                  </div> */}
              </div>
            </div>


            {/* ===== CATEGORY ===== */}
            {subscription.category && (
              <div className="mb-4">
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                  Category
                </h6>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Category Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={subscription.category.name || "-"}
                      readOnly
                    />
                  </div>

                  {/* <div className="col-md-12">
                    <label className="form-label">Category Description</label>
                    <textarea
                      rows={3}
                      className="form-control"
                      value={subscription.category.description || "-"}
                      readOnly
                    />
                  </div> */}
                </div>
              </div>
            )}

            {/* ===== FEATURES ===== */}
            {/* <div className="mb-4">
            <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
              Features
            </h6>

            {Array.isArray(subscription.features) &&
              subscription.features.length > 0 ? (
              <div className="row g-2">
                {subscription.features.map((feature, idx) => (
                  <div className="col-md-6" key={idx}>
                    <div className="d-flex align-items-center border rounded px-3 py-2">
                      <span className="badge bg-primary me-2">
                        {idx + 1}
                      </span>
                      <span>{feature}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted mb-0">No features</p>
            )}
          </div> */}

            {/* ===== TIMESTAMPS ===== */}
            <div className="mb-2">
              <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">
                Timestamps
              </h6>

              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Created At</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatDateTime(subscription.created_at)}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Updated At</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formatDateTime(subscription.updated_at)}
                    readOnly
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div >
    </>
  );
}

export default ViewPlan;